export default __webpack_public_path__ + "static/media/time32.61b66bec.svg";